import React, { ReactElement } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { colors, fontSizes } from "../theme";

interface InfoRowProps {
  label: string;
  value: string | number | ReactElement;
  date?: Date;
  labelWidth?: number;
  valueFontWeight?: "bold" | "normal";
}

const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  date,
  labelWidth = 190,
  valueFontWeight = "bold",
}) => {
  return (
    <Stack direction="row" mt={1}>
      <Box sx={{ width: labelWidth }}>
        <Typography fontSize={fontSizes.sm} color={colors.stone[500]}>
          {label}
        </Typography>
      </Box>
      <Stack direction="row" gap={1} maxWidth={250}>
        <Typography
          variant={"medium"}
          textAlign={"left"}
          color={colors.stone[900]}
          fontSize={fontSizes.sm}
          fontWeight={valueFontWeight}
        >
          {value}
        </Typography>
        {date && (
          <Typography textAlign={"left"} variant="body2">
            ({date.toLocaleDateString()})
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default InfoRow;
